
import HeroSection from './components/HeroSection';
import AboutPSU from './components/AboutPSU';
import StreamerRecruitment from './components/StreamerRecruitment';
import StreamerRewards from './components/StreamerRewards';
import Leaderboard from './components/Leaderboard';
import StreamToEarn from './components/StreamToEarn';
import Collaborations from './components/Collaborations';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <HeroSection />
      <AboutPSU />
      <StreamerRecruitment />
      <StreamerRewards />
      <Leaderboard />
      <StreamToEarn />
      <Collaborations />
      <ContactSection />
    </div>
  );
}
